import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '../services/account.service';

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  if (!localStorage.getItem('token')) {
    inject(Router).navigate(['/login']);
    return false;
  }
  return true;
};

export const financeAccessGuard: CanActivateFn = () => {
  const accountService = inject(AccountService);
  const router = inject(Router);
  if (accountService.hasFinanceAccess()) {
    return true;
  }
  router.navigate(['/dashboard/cupom-parceiro']);
  return false;
};

export const staffOnlyGuard: CanActivateFn = () => {
  const accountService = inject(AccountService);
  const router = inject(Router);
  if (accountService.isStaff()) {
    return true;
  }
  router.navigate(['/dashboard/transactions']);
  return false;
};
